/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Stuck_NothingInputs */

const vi_einvoice_stuck_nothing = /** @type {(inputs: Einvoice_Stuck_NothingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MISA chưa có hóa đơn mang mã của ERP cho đơn này. Có thể đơn đã được xuất tay trên web MISA.`)
};

/**

* @param {Einvoice_Stuck_NothingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_stuck_nothing = /** @type {((inputs?: Einvoice_Stuck_NothingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Stuck_NothingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_stuck_nothing(inputs)
});